/*=========================================================================================
  File Name: modulewalmart.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from './moduleWalmartState.js';
import mutations from './moduleWalmartMutations.js';
import actions from './moduleWalmartActions.js';
import getters from './moduleWalmartGetters.js';

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
